import MathTool from "./MathTool";

export default class EasingTool {
    static functionNames = ["linear", "easeInOutQuad", "easeInQuad", "easeOutQuad", "easeOutIn", "easeOutBounce", "easeInOutCirc"]

    static linear(x) {
        return x;
    }

    static easeInOutQuad(x) {
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    }

    static easeInQuad(x) {
        return x * x;
    }

    static easeOutQuad(x) {
        return 1 - (1 - x) * (1 - x);
    }

    static easeOutIn(x) {
        const m0 = 2.5;
        const m1 = 2.5;
        return (Math.pow(x, 3) - 2 * Math.pow(x, 2) + x) * m0 + (-2 * Math.pow(x, 3) + 3 * Math.pow(x, 2)) + (Math.pow(x, 3) - Math.pow(x, 2)) * m1;
    }

    static easeOutBounce(x) {
        const n1 = 7.5625;
        const d1 = 2.75;

        if (x < 1 / d1) {
            return n1 * x * x;
        } else if (x < 2 / d1) {
            return n1 * (x -= 1.5 / d1) * x + 0.75;
        } else if (x < 2.5 / d1) {
            return n1 * (x -= 2.25 / d1) * x + 0.9375;
        } else {
            return n1 * (x -= 2.625 / d1) * x + 0.984375;
        }
    }
    
    static easeInOutCirc(x) {
        return x < 0.5
            ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2
            : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
    }

    static getRandomEasingFunction(){
        return EasingTool[MathTool.randomElementFromArray(
            EasingTool.functionNames
        )];
    }
}


